export default __webpack_public_path__ + "static/media/img10.9a3acd7f.png";